import uniqBy from 'lodash/uniqBy';
import { getFileSize } from 'app/utils/attachments';
import { ContentType } from '../../types';
export function parseJSONFromResponse(response) {
    try {
        const { data: { data: { body, error_message }, }, } = response;
        const jsonResponse = body || error_message || {};
        try {
            return JSON.parse(jsonResponse);
        }
        catch (_error) {
            return jsonResponse;
        }
    }
    catch (_a) {
        return 'Invalid url data';
    }
}
export function getStatusFromResponse(response, startTime) {
    if (!response) {
        return [
            {
                name: 'Status',
                text: 'No response.',
                color: 'DEFAULT',
            },
        ];
    }
    const responseTime = Date.now() - startTime;
    const contentLength = response.headers
        ? parseInt(response.headers['content-length'], 10)
        : 0;
    const prettySize = getFileSize(contentLength);
    const UNKNOWN = 'Unknown';
    const { data: { data: { status_code = UNKNOWN, content_type = UNKNOWN } = {} } = {}, } = response;
    const isErrorStatus = status_code === UNKNOWN || status_code >= 400;
    return [
        {
            name: 'Status',
            text: status_code,
            color: isErrorStatus ? 'RED' : 'GREEN',
        },
        {
            name: 'Size',
            text: prettySize,
            color: contentLength > 1048576 || contentLength === 0 ? 'RED' : 'DEFAULT',
        },
        {
            name: 'Time',
            text: `${responseTime} ms`,
            color: responseTime >= 2500 ? 'RED' : 'GREEN',
        },
        {
            name: 'Content-type',
            text: content_type,
            color: content_type === ContentType.APPLICATION_JSON ? 'DEFAULT' : 'RED',
        },
    ];
}
export function getVariables(availableFlowVariables, formValues) {
    if (formValues) {
        const { url, body } = formValues;
        const variables = [];
        const findScopeVars = /{{(([^:]*:)?([^}]+))}}/g;
        let match;
        while ((match = findScopeVars.exec(url + body)) !== null) {
            const matchVar = findVariableMatch(availableFlowVariables, match[1]);
            if (matchVar) {
                variables.push({
                    key: match[1],
                    label: matchVar.content,
                });
            }
        }
        return uniqBy(variables, 'key');
    }
    return [
        {
            key: '',
            label: '',
        },
    ];
}
function findVariableMatch(availableFlowVariables, key) {
    return availableFlowVariables.reduce((pre, category) => {
        if (pre)
            return pre;
        const categoryMatch = category.items.find((variable) => {
            return variable.name === key;
        });
        if (categoryMatch) {
            return categoryMatch;
        }
        return pre;
    }, null);
}
